import { createContext } from 'react';

import { NodeValidationError, WorkflowValidationError } from '../types/node-validation';

export type WorkflowErrorContextValue = {
  /** Whether to show validation errors on nodes */
  showErrors: boolean;
  /** Toggle the showErrors state */
  setShowErrors: (value: boolean) => void;
  /** Node-level validation errors */
  nodeErrors: NodeValidationError[];
  /** Workflow-level validation errors */
  workflowErrors: WorkflowValidationError[];
  /** Get errors for a specific node */
  getNodeErrors: (nodeId: string) => NodeValidationError[];
};

export const WorkflowErrorContext = createContext<WorkflowErrorContextValue | null>(null);

WorkflowErrorContext.displayName = 'WorkflowErrorContext';
